<template>
  <div
    class="auth-wrapper auth-v1"
    style="background-color: #eff1f3"
  >
    <div class="auth-inner py-2">

      <!-- Register v1 -->
      <b-card class="mb-0">
        <b-link
          class="brand-logo"
          @click="$router.push('/')"
        >
          <logo-vsl-booster />

        </b-link>
        <validation-observer ref="registerForm">
          <b-form
            class="auth-register-form"
            @submit.prevent
          >
            <b-row>
              <b-col cols="12">
                <div class="my-6 text-center"><h4
                  class="font-bold"
                  style="font-size: 26px; color: green;"
                >
                  Boleto Gerado!
                </h4></div>
              </b-col>
              <b-col
                cols="12"
                style="padding: 1rem 4rem"
              >
                <div class="pb-6 px-12 text-justify">
                  Após o pagamento do boleto, você receberá acesso à nossa plataforma. Agradecemos a compreensão de que a confirmação do pagamento pode levar até 48 horas.
                </div>
              </b-col>
              <b-col cols="12">
                <div class="text-center">
                 <b>Valor do boleto</b>
                </div>
                <div class="text-center font-bold">
                  R$ {{ converteValue(data_payment.amount) }}
                </div>
              </b-col>
              <b-col cols="12">
                <div class="text-center mt-2">
                  <b>Data de vencimento</b>
                  <p class="font-bold">
                    {{ data_payment.due_at | formatDate }}
                  </p></div>
              </b-col>
              <b-col cols="12">
                <div class="text-center mt-2 mb-8 px-10">
                  <b>Código do Boleto</b>
                  <p class="font-bold">
                    {{ data_payment.line }}
                  </p></div>
              </b-col>
              <b-col cols="12">
                <div class="text-center mb-4 px-10">
                  <img
                    :src="data_payment.barcode"
                    alt="Codigo de barra"
                  >
                </div>
              </b-col>

              <b-col cols="12">

                <div class="d-flex justify-content-center my-1">
                  <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-primary"
                    style="width: 400px"
                    @click="copyCode"
                  >
                    <span class="text-uppercase align-middle">Copiar Código</span>
                  </b-button>
                </div>
              </b-col>
              <b-col cols="12">

                <div class="d-flex justify-content-center mb-1">
                  <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="primary"
                    style="width: 400px"
                    @click="downloadPDFBoleto"
                  >
                    <span class="text-uppercase align-middle">Abrir Boleto</span>
                  </b-button>
                </div>
              </b-col>

              <b-col
                cols="12"
                class="text-center"
              >
                <p>
                  Também enviamos um link do boleto ao seu email <b>{{ userData.user_email }}</b>.
                </p>
              </b-col>
            </b-row>

          </b-form>
        </validation-observer>
        <b-overlay
          :show="false"
          no-wrap
        >
          <b-skeleton
            class="w-100"
            height="100%"
            type="form"
            variant="light"
          />
        </b-overlay>
      </b-card>
    </div>
  </div>

</template>

<script>
import { ValidationObserver } from 'vee-validate'
import {
  BCard, BLink, BForm, VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import LogoVslBooster from '@/components/LogoVslBooster.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { formatDate } from '@core/utils/utils'

export default {
  components: {
    LogoVslBooster,
    // BSV
    BCard,
    BLink,
    BForm,
    // validations
    ValidationObserver,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  filters: {
    formatDate,
  },
  data() {
    return {
      interval: null,
    }
  },
  computed: {
    data_payment() {
      return this.$store.getters['appPayment/data_payment']
    },
    userData() {
      return this.$store.getters['User/getUser']
    },
  },
  mounted() {
    if (this.data_payment === null) {
      this.$router.push({ name: 'payment' })
    }

    // this.interval = setInterval(() => {
    //   this.$store.dispatch('appPayment/findByIdOrder', { id: this.$store.getters['appPayment/id_pedido_pagarme'] })
    //     .then(resp => {
    //       if (resp.data.success) {
    //         if (resp.data.data.status === 'paid') {
    //           this.$toast({
    //             component: ToastificationContent,
    //             props: {
    //               title: 'Aprovação',
    //               text: 'Pagamento aprovado com sucesso!',
    //               icon: 'CheckIcon',
    //               variant: 'success',
    //             },
    //           })
    //           this.$router.push('/dashboard')
    //         }
    //       }
    //     })
    // }, 120000)
  },
  destroyed() {
    clearInterval(this.interval)
  },
  methods: {
    converteValue(val) {
      const valorReal = val / 100
      return valorReal.toLocaleString('pt-br', { minimumFractionDigits: 2 })
    },
    copyCode() {
      const el = document.createElement('textarea')
      el.value = this.data_payment.line
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Código copiado',
          text: 'O código foi copiado com sucesso!',
          icon: 'CheckIcon',
          variant: 'success',
        },
      })
    },

    async downloadPDFBoleto() {
      window.open(this.data_payment.pdf, '_blank', 'width=800,height=800,toolbar=0,location=0,menubar=0,status=0');
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/pages/page-auth.scss';

.auth-wrapper.auth-v1 .auth-inner {
  max-width: 600px !important;
}
</style>
